<template>
	<div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
		</div>
		<div v-else class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<template v-slot:header>
							<i class="icon-pencil"></i> Edit Purchase Order
						</template>
						<b-card-body>
							<b-form @submit.prevent="checkFormValidity()" method="post">
								<b-form-group
									label="Project Name"
									label-for="projectName"
									:label-cols="3"
									:horizontal="true">
									<b-form-input
										id="projectName"
										name="projectName"
										type="text"
										:value="purchaseOrder.projectName"
										disabled></b-form-input>
								</b-form-group>
								<b-form-group
									label="Date of Purchase" label-for="purchaseDate"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<b-form-input v-model="form.purchaseDate" name="purchaseDate" type="date" id="purchaseDate" :state="$v.form.purchaseDate.$dirty ? !$v.form.purchaseDate.$error : null" aria-describedby="purchase-date-live-feedback"></b-form-input>
									<b-form-invalid-feedback id="purchase-date-live-feedback">This is a required field.</b-form-invalid-feedback>
								</b-form-group>
								<b-form-group
									label="Number of Devices"
									label-for="deviceQuantity"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<b-form-input v-model="form.deviceQuantity" name="deviceQuantity" id="deviceQuantity" type="number" placeholder="Quantity" :state="$v.form.deviceQuantity.$dirty ? !$v.form.deviceQuantity.$error : null" aria-describedby="device-quantity-live-feedback"></b-form-input>
									<b-form-invalid-feedback id="device-quantity-live-feedback">This is a required field and must not be 0.</b-form-invalid-feedback>
								</b-form-group>
								<b-form-group
									label="Device Unit Price"
									label-for="deviceUnitPrice"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<b-form-input v-model="form.deviceUnitPrice" name="deviceUnitPrice" id="deviceUnitPrice" type="number" placeholder="Price" :state="$v.form.deviceUnitPrice.$dirty ? !$v.form.deviceUnitPrice.$error : null" aria-describedby="unit-price-live-feedback"></b-form-input>
									<b-form-invalid-feedback id="unit-price-live-feedback">This is a required field and must not be 0.</b-form-invalid-feedback>
								</b-form-group>
								<b-form-group
									label="Select Software Version"
									label-for="version-id"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<b-form-select v-model="form.versionId"
																 name="versionId"
																 id="version-id"
																 :plain="true"
																 :options="versionNameDropDownList"
																 value="Please Select"
																 :state="$v.form.versionId.$dirty ? !$v.form.versionId.$error : null"
																 aria-describedby="version-live-feedback">
									</b-form-select>
									<b-form-invalid-feedback id="version-live-feedback">Please select one.</b-form-invalid-feedback>
								</b-form-group>
								<b-form-group
									label="Software Package Fee"
									label-for="software-package-fee"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<b-form-input v-model="form.softwarePackageFee" name="softwarePackageFee" id="software-package-fee" type="number" placeholder="Package Price" :state="$v.form.softwarePackageFee.$dirty ? !$v.form.softwarePackageFee.$error : null" aria-describedby="software-package-fee-live-feedback"></b-form-input>
									<b-form-invalid-feedback id="software-package-fee-live-feedback">This is a required field and must not be 0.</b-form-invalid-feedback>
								</b-form-group>
								<b-row>
									<b-col>
										<b-card title="Client Information">
											<b-card-body>
												<b-form-group
													label="Name"
													label-for="client-name"
													label-class="required"
													:label-cols="3"
													:horizontal="true">
													<b-form-input
														v-model="form.clientName"
														name="clientName"
														id="client-name"
														type="text"
														placeholder="Client Name"
														:state="$v.form.clientName.$dirty ? !$v.form.clientName.$error : null"
														aria-describedby="client-name-live-feedback">
													</b-form-input>
													<b-form-invalid-feedback id="client-name-live-feedback">This is a required field and must not be empty.</b-form-invalid-feedback>
												</b-form-group>
												<b-form-group
													label="Email"
													label-for="client-email"
													:label-cols="3"
													:horizontal="true">
													<b-form-input
														v-model="form.clientEmail"
														name="clientEmail"
														id="client-email"
														type="text"
														placeholder="Client Email"
														:state="$v.form.clientEmail.$dirty ? !$v.form.clientEmail.$error : null"
														aria-describedby="client-email-live-feedback">
													</b-form-input>
													<b-form-invalid-feedback id="client-email-live-feedback">Invalid Email Address.</b-form-invalid-feedback>
												</b-form-group>
												<b-form-group
													label="Phone"
													label-for="client-phone"
													:label-cols="3"
													:horizontal="true">
													<b-form-input
														v-model="form.clientPhone"
														name="clientPhone"
														id="client-phone"
														type="text"
														placeholder="Client Phone No."
														:state="$v.form.clientPhone.$dirty ? !$v.form.clientPhone.$error : null"
														aria-describedby="client-phone-live-feedback">
													</b-form-input>
													<b-form-invalid-feedback id="client-phone-live-feedback">Invalid Phone Number.</b-form-invalid-feedback>
												</b-form-group>
												<b-form-group
													label="Company"
													label-for="client-company"
													label-class="required"
													:label-cols="3"
													:horizontal="true">
													<b-form-input
														v-model="form.clientCompany"
														name="clientCompany"
														id="client-company"
														type="text"
														placeholder="Client Company Name"
														:state="$v.form.clientCompany.$dirty ? !$v.form.clientCompany.$error : null"
														aria-describedby="client-company-live-feedback">
													</b-form-input>
													<b-form-invalid-feedback id="client-company-live-feedback">This is a required field and must not be empty.</b-form-invalid-feedback>
												</b-form-group>
												<b-form-group
													label="Address"
													label-for="client-address"
													:label-cols="3"
													:horizontal="true">
													<b-form-input
														v-model="form.clientAddress"
														name="clientAddress"
														id="client-address"
														type="text"
														placeholder="Client Address"
														:state="$v.form.clientAddress.$dirty ? !$v.form.clientAddress.$error : null"
														aria-describedby="client-address-live-feedback">
													</b-form-input>
													<b-form-invalid-feedback id="client-address-live-feedback">Invalid Address.</b-form-invalid-feedback>
												</b-form-group>
											</b-card-body>
										</b-card>
									</b-col>
								</b-row>
								<div class="form-actions">
									<b-button v-if="$store.getters.canWrite" type="submit" variant="primary"><i class="fa fa-dot-circle-o"></i> Update P.O.</b-button>
									&nbsp;
									<b-button type="button" variant="danger" @click="resetForm()"><i class="fa fa-ban"></i> Reset</b-button>
								</div>
							</b-form>
						</b-card-body>
					</b-card>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import purchaseOrderService from "@/services/purchaseOrderService";
import moment from "moment";
import toastService from "@/services/toastService";
import { required, numeric, minValue, requiredIf, email, maxValue } from "vuelidate/lib/validators";
import versionService from "@/services/versionService";

export default {
	name : "editPurchaseOrder",
	data : function () {
		return {
			purchaseOrderId : this.$route.params.purchaseOrderId,
			purchaseOrder : null,
			form : {
				purchaseDate : null,
				deviceQuantity : null,
				deviceUnitPrice : null,
				versionId : null,
				softwarePackageFee : null,
				clientName : null,
				clientEmail : null,
				clientCompany : null,
				clientPhone : null,
				clientAddress : null
			},
			versions : [],
			versionNameDropDownList : [
				{text: "Please Select", value: null}
			],
			loading : false
		}
	},
	validations : {
		form : {
			purchaseDate : {
				required
			},
			deviceQuantity : {
				required,
				minValue: minValue(1)
			},
			deviceUnitPrice : {
				required,
				minValue: minValue(1)
			},
			versionId : {
				required,
				minValue : minValue(1),
				maxValue : maxValue(3)
			},
			softwarePackageFee : {
				required,
				minValue : minValue(1)
			},
			clientName : {
				required
			},
			clientEmail : {
				validEmail : email
			},
			clientCompany : {
				required
			},
			clientPhone : {

			},
			clientAddress : {

			}
		}
	},
	methods : {
		getPurchaseOrderDetails : function () {
			this.loading = true;
			purchaseOrderService.getPurchaseOrder(this.purchaseOrderId, (data) => {
				this.purchaseOrder = data;
				this.loading = false;
				if(this.purchaseOrder.deliveryStatus === 0) {
					this.purchaseOrder.purchaseDate = moment(data.purchaseDate).format("YYYY-MM-DD");
					this.initForm();
				} else {
					toastService.showErrorToast("This purchase order is not editable");
					this.$router.replace("/purchase-orders/list");
				}
			}, (error) => {
				this.loading = false
				toastService.showErrorToast("Could not fetch purchase order details " + error);
			});
		},
		initForm : function () {
			this.form.purchaseDate = this.purchaseOrder.purchaseDate;
			this.form.deviceQuantity = this.purchaseOrder.deviceQuantity;
			this.form.deviceUnitPrice = this.purchaseOrder.unitPrice;
			this.form.versionId = this.purchaseOrder.versionId;
			this.form.softwarePackageFee = this.purchaseOrder.softwarePackageFee;
			this.form.clientName = this.purchaseOrder.clientName;
			this.form.clientEmail = this.purchaseOrder.clientEmail;
			this.form.clientPhone = this.purchaseOrder.clientPhone;
			this.form.clientAddress = this.purchaseOrder.clientAddress;
			this.form.clientCompany = this.purchaseOrder.clientCompanyName;
		},
		checkFormValidity : function(){
			let formHasErrors = false;

			this.$v.form.$touch();
			if (this.$v.form.$anyError) {
				formHasErrors = true;
			}

			if(formHasErrors) return;
			else this.updatePurchaseOrder();
		},
		updatePurchaseOrder : function () {
			const formData = {
				purchaseDate: new moment(this.form.purchaseDate,'YYYY-MM-DD').format('x'),
				deviceQuantity: this.form.deviceQuantity,
				deviceUnitPrice: this.form.deviceUnitPrice,
				versionId: this.form.versionId,
				softwarePackageFee: this.form.softwarePackageFee,
				clientName: this.form.clientName.trim(),
				clientEmail: this.form.clientEmail ? this.form.clientEmail.trim() : null,
				clientPhone: this.form.clientPhone ? this.form.clientPhone.trim() : null,
				clientCompanyName: this.form.clientCompany.trim(),
				clientAddress: this.form.clientAddress ? this.form.clientAddress.trim() : null
			}

			purchaseOrderService.updatePurchaseOrder(this.purchaseOrderId, formData, (data) => {
				this.resetForm();
				toastService.showSuccessToast("Purchase order created successfully");
				this.$router.back();
			}, (error) => {
				this.$nextTick(() => { this.$v.$reset() });
				toastService.showErrorToast("Could not create purchase order " + error);
			});
		},
		resetForm: function () {
			this.$nextTick(() => { this.$v.$reset() });
			this.initForm();
		},
		getVersionNameList() {
			versionService.getVersionNameList((data) => {
				this.versions = data;
				this.createVersionNameDropDownList();
			}, (error) => {
				toastService.showErrorToast("Could not fetch version list" + error);
			});
		},
		createVersionNameDropDownList : function () {
			this.versions.forEach((value => {
				let version = new Object();
				version.text = value.name;
				version.value = value.id;
				this.versionNameDropDownList.push(version);
			}));
		}
	},
	watch: {
		$route(to, from) {

		}
	},
	created() {
		this.getVersionNameList();
		this.getPurchaseOrderDetails();
	}
}
</script>

<style scoped>

</style>
